import React from "react";
import cx from "classnames";
import { Link } from "react-router-dom";
import { useContextPerson } from "hooks/persons";
import styles from "./AppDevTools.module.styl";
import { useFrontendAppVersion } from "hooks/useFrontendAppVersion";

export function AppDevTools() {
    const { showDevTools, appVersion: backendVersion } = useContextPerson();
    const frontendVersion = useFrontendAppVersion();

    if (!showDevTools) {
        return null;
    }

    const versionMismatch = backendVersion !== frontendVersion;
    const versionClassName = cx(styles.version, versionMismatch && styles.versionMismatch);

    return (
        <div className={styles.root}>
            <div className={styles.links}>
                <a
                    className={styles.link}
                    href={"/swagger"}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Swagger
                </a>
                /
                <Link className={styles.link} to={"/uikit"} target="_blank">
                    UI-kit
                </Link>
                /
                <a
                    className={styles.link}
                    href={"/health"}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Health status
                </a>
                /
                <a
                    className={styles.link}
                    href={"/healthz"}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Health details
                </a>
            </div>
            <div className={versionClassName} title={backendVersion}>
                Backend version: {backendVersion}
            </div>
            <div className={versionClassName} title={frontendVersion}>
                Frontend version: {frontendVersion}
            </div>
        </div>
    );
}
